// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import React from 'react';
import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import InternalToggle from './internal';
const Toggle = React.forwardRef((props, ref) => {
    const baseComponentProps = useBaseComponent('Toggle', { props: { readOnly: props.readOnly } });
    return React.createElement(InternalToggle, { ...props, ...baseComponentProps, ref: ref, __injectAnalyticsComponentMetadata: true });
});
applyDisplayName(Toggle, 'Toggle');
export default Toggle;
//# sourceMappingURL=index.js.map